/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Modal,
  StyleProp,
  Text,
  TouchableHighlight,
  View,
  ViewStyle,
} from 'react-native';
import {styles} from '../Popup/styles';
import {styles as modalStyles} from './styles';

interface Props {
  content?: string;
  title?: string;
  exit?: any;
  children?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}
const ModalFC = ({
  content,
  title = 'Information',
  exit,
  children,
  style,
}: Props) => {
  return (
    <View style={styles.centeredView}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={true}
        onRequestClose={() => {}}>
        <View style={styles.centeredView}>
          <View style={[styles.modalView, style]}>
            <Text style={[styles.modalText, styles.bold, {width: '100%'}]}>
              {title}
            </Text>
            {content ? <Text style={[styles.modalText]}>{content}</Text> : null}

            {children}

            {typeof exit === 'function' ? (
              <TouchableHighlight
                style={{...styles.openButton1, ...modalStyles.touchable}}
                onPress={exit}>
                <Text style={[modalStyles.textStyle, styles.textStyle1]}>
                  Quitter
                </Text>
              </TouchableHighlight>
            ) : null}
          </View>
        </View>
      </Modal>
    </View>
  );
};

export default ModalFC;
